const devices = ['ios', 'android', 'web', 'kiosco'];
type TDevice = (typeof devices)[number];

import { EDevice } from '@/constants';
import {
  isAndroidAnalyticsReadyToUse,
  isIosAnalyticsReadyToUse
} from '@/modules/perseo-billing/utils';

export const validateDeviceReadiness = (device: TDevice) => {
  if (device === EDevice.IOS && !isIosAnalyticsReadyToUse()) {
    throw new Error('ios analytics is not ready');
  }

  if (device === EDevice.ANDROID && !isAndroidAnalyticsReadyToUse()) {
    throw new Error('android analytics is not ready');
  }

  if (devices.includes(device)) {
    return;
  }

  throw new Error(`Device "${device}" is not supported`);
};
